module.exports = __webpack_public_path__ + "static/media/bottle.791ab279.JPG";